function addSizeFormat(sizeObj = {}) {
  const {
    size = '',
    brandSize = '',
    universalSize: standardSize = '',
    sizeFormat = '',
    standardSizeFormat = '',
    sizeDisplayType = ''
  } = sizeObj;

  const sizeFormatObj = {};
  const brandSizeVal = brandSize || size;
  // add format value to respective sizes
  sizeFormatObj.brandSizeWithFormat =
    sizeFormat && sizeFormat !== 'UNI' && brandSizeVal
      ? `${sizeFormat} ${brandSizeVal}`
      : brandSizeVal; //  if brandSize value not there pass size value
  sizeFormatObj.standardSizeWithFormat =
    standardSizeFormat && standardSizeFormat !== 'UNI' && standardSize
      ? `${standardSizeFormat} ${standardSize}`
      : standardSize;

  sizeFormatObj.sizeDisplayType = sizeDisplayType;
  sizeFormatObj.standardSize = standardSize;
  sizeFormatObj.brandSize = brandSizeVal;
  sizeFormatObj.sizeFormat = sizeFormat !== 'UNI' ? sizeFormat : '';
  sizeFormatObj.standardSizeFormat = standardSizeFormat !== 'UNI' ? standardSizeFormat : '';
  return sizeFormatObj;
}

const filterSizes = (acc, itemSize) => ({ ...acc, [itemSize.qualifier]: itemSize.value });
const filterAttributes = (acc, itemSize) => ({ ...acc, [itemSize.name]: itemSize.value });

export function fetchSizeAndBrandSize(variantOptionQualifier = [], newSizeRevampFlag) {
  const sizeObj = variantOptionQualifier.reduce(filterSizes, {});

  const {
    brandSizeWithFormat = '',
    standardSizeWithFormat = '',
    sizeDisplayType = '',
    standardSize = '',
    brandSize = '',
    sizeFormat = '',
    standardSizeFormat = ''
  } = addSizeFormat(sizeObj);

  const showSizes = {};

  if (sizeDisplayType === 'BRAND') {
    showSizes.sizeUI = brandSizeWithFormat;
    showSizes.Size = brandSize;
  } else if (sizeDisplayType === 'STANDARD') {
    if (sizeFormat === standardSizeFormat && standardSize === brandSize) {
      showSizes.sizeUI = standardSizeWithFormat; // not show brand size
      showSizes.Size = standardSize;
    } else {
      showSizes.sizeUI = standardSizeWithFormat;
      showSizes.brandSizeUI = brandSizeWithFormat;
      showSizes.Size = standardSize; // show brand size
    }
  }
  showSizes.sizeType = sizeDisplayType === 'BRAND' ? sizeFormat : standardSizeFormat;

  return newSizeRevampFlag ? showSizes : {};
}
const getQualifierToValueMap = (acc, itemSize) =>
  itemSize.qualifier ? { ...acc, [itemSize.qualifier.toLowerCase()]: itemSize.value } : { ...acc };

export function beautyCheck(variantOptionQualifier = [], onlySize) {
  const sizeObj = variantOptionQualifier.reduce(getQualifierToValueMap, {});
  const { selection1 = '', selection2 = '', uom = '' } = sizeObj;
  let valueWithUnit = '';
  const qualifierKey1 = selection1 ? selection1.toLowerCase() : '';
  const qualifierKey2 = selection2 ? selection2.toLowerCase() : '';

  // Defect: 416141- We are removing OR check for metalpurity maintaining parity with android implementation.
  if (qualifierKey2 && (qualifierKey2 !== 'size')) {
    valueWithUnit = `${sizeObj[qualifierKey2]} ${uom}`;
  }
  if (qualifierKey2 === 'null') {
    valueWithUnit = '';
  }
  if (qualifierKey1 === 'metalpurity' && !onlySize) {
    valueWithUnit = valueWithUnit ? `${sizeObj[qualifierKey1]} | ${valueWithUnit}`: sizeObj[qualifierKey1];
  }

  let hideSizes = false;
  // case when only color are there no sizes so hide size select section
  hideSizes = (selection2 === 'NULL' || !selection2) && qualifierKey1 === 'color';

  return {
    valueWithUnit,
    hideSizes
  };
}
